import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import {
  fetchKeywordCoveragePage,
  type KeywordCoverageSort,
  type SortDirection,
} from '@/api/keywordCoverage/api'
import type { KeywordCoveragePage } from '@/api/keywordCoverage/types'

export function useKeywordCoverage(
  page: number,
  pageSize: number,
  sort: KeywordCoverageSort,
  direction: SortDirection,
): UseQueryResult<KeywordCoveragePage> {
  return useQuery({
    queryKey: ['keyword-coverage', page, pageSize, sort, direction],
    queryFn: ({ signal }) => fetchKeywordCoveragePage(page, pageSize, sort, direction, signal),
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  })
}
